import React, {useContext, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import AuthContext from "../../../../context/AuthContext";
import useStyles from './styles';

function ValidatePassphraseSuccess(props) {
    const classes = useStyles();
    const history = useHistory();
    const {setHasValidatedPassphrase} = useContext(AuthContext);
    const {goBack, validationResponse} = props;

    useEffect(() => {
        setTimeout(function(){
            if (validationResponse?.message === "Password is correct!") {
                setHasValidatedPassphrase(true)
                history.push('/form')
            } else {
                goBack()
            }
        }, 3000);
    }, []);

    return (
        <React.Fragment>
                <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column', width:'100%'}}>
                    {validationResponse?.message !== "Password is correct!"
                        ? <p className={classes.wrongPassphrase}>Contraseña incorrecta</p>
                        : <p className={classes.rightPassphrase}>Contraseña aceptada</p>
                    }
                    <p className={classes.redirectingPassphrase}>Redirigiendo...</p>
                </div>
        </React.Fragment>
    );
}

export default ValidatePassphraseSuccess;